let baseUrl
switch (process.env.NODE_ENV){
  case 'development':
    baseUrl = 'http://192.168.1.101:7001'
    // baseUrl = 'http://192.168.10.148:7001'
    // baseUrl = 'http://139.196.215.119:7001'
    // baseUrl = 'http://127.0.0.1:7001'
    // baseUrl = 'http://139.196.215.119:7001'
    break;
  case 'production':
    baseUrl = 'http://139.196.215.119:7001'
}
export default baseUrl



// WEBPACK FOOTER //
// ./src/utils/url.js